import {Divider, styled} from '@mui/material'
import {Colors, Texts} from 'appearance'

const TableTitle = ({title, subtitle, icon}) => {
    const PageIcon = icon
    return (
        <TitleWrapper>
            <div style={{display: 'flex', gap: 14, alignItems: 'center'}}>
                <PageIcon
                    style={{
                        width: 34,
                        height: 22,
                    }}
                />
                <TitleText>{title}</TitleText>
            </div>
            <TitleText>{subtitle}</TitleText>
            <TitleDivider />
        </TitleWrapper>
    )
}

export default TableTitle

const TitleWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    width: 20%;
    margin-bottom: 20px;
`

const TitleText = styled(Texts.RegularText)`
    font-size: 28px;
    font-weight: 600;
`

const TitleDivider = styled(Divider)`
    margin-top: 10px;
    border-color: ${Colors.PRIMARY_TEXT};
`
